// extracted by mini-css-extract-plugin
module.exports = {"drawer":"AddPositionsDrawer_drawer__3CHNE","baricon":"AddPositionsDrawer_baricon__3kTi9","addBtn":"AddPositionsDrawer_addBtn__bJibX","btnText":"AddPositionsDrawer_btnText__1MhoR"};